import React, { Component } from 'react';
import ReactGA from 'react-ga';
import titleBox from './image/livestream/livestream_titletext.jpg';
class LiveStream extends Component {
	componentWillMount() {
		ReactGA.set({
			'dimension1': ':mini:fashionweekfw17',
			'dimension2': ':mini',
			'dimension3': ':mini:fashionweekfw17',
			'dimension4': ':mini:fashionweekfw17:liveStream'
		});
		ReactGA.pageview('/#liveStream');
	}
	render() {
		return (
			<div className="liveStream">
				<div className="sub-page-header">
					<div className="sub-page-title">
						<div>
							<img alt="LIVE STREAM" src={titleBox} />
						</div>
					</div>
				</div>
				<div className="sub-page-content">
					<div className="graphic">
						<div className="graphic1"></div>
						<div className="graphic2"></div>
						<div className="graphic3"></div>
						<div className="graphic4"></div>
					</div>
					<div id="scrollable-area" className="scrollable-area">
						<div className="items">
							{
								this.props.data.data.map(function(item, index) {
									return (
											<div key={index} className="item">
												<a href={item.destination_url+"?utm_source=mini&utm_medium=campaign&utm_campaign=fashionweekfw17"} target="_blank">
													<img className="for-desktop" src={"http://campaign.esquirehk.com/"+item.entry_image} alt="" />
													<img className="for-mobile" src={"http://campaign.esquirehk.com/"+item.entry_image_optional} alt="" />
													<p>{item.text}</p>
												</a>
											</div>
									)
								})
							}
						</div>
					</div>
				</div>
				<div className="fixed-on-bottom">
					<div className="fixed-esky-container">
						<div className="fixed-esky"></div>
					</div>
				</div>
			</div>
		);
	}
}

export default LiveStream;


// WEBPACK FOOTER //
// ./src/LiveStream.js